/**
 * A VALUE DROPPED INTO A SENTENCE, ISOLATED.
 *
 * `'غرفة {room}'.replace('{room}', '305')` produces ONE text node holding an Arabic word
 * and a Latin number, and the bidirectional algorithm then decides where the number goes
 * relative to everything around it — including any punctuation that follows. That has
 * cost this project three times: a mid-dot landing in the middle of an Arabic date on
 * the roster, and — Sprint 24 — a minus sign appearing on the WRONG SIDE of every
 * negative figure on the count variance, because U+2212 beside Arabic-Indic digits is
 * a neutral character and takes the paragraph's direction rather than the number's.
 *
 * `<bdi>` is the whole fix and it is one element: it isolates the value so the sentence
 * reads the same whichever direction it is in, and whatever the value turns out to hold.
 *
 * It lives here, in the component library, because it is now needed by the portal, the
 * guest form and anything drawn after them — and the copy that drifts is always the one
 * nobody runs.
 */
export function Interpolate({
  template, slot, value,
}: { template: string; slot: string; value: string }) {
  const [before, after = ''] = template.split(slot)
  return <>{before}<bdi>{value}</bdi>{after}</>
}
